import getSupportCommercial from '@/services/catalogue/getSupportCommercial';
import { CATEGORIE_SALON } from '@/configuration/catalogue/produitConf';
import entiteCommercialeGenerer from '@/services/entiteCommerciale/genererEntiteCommerciale';
import { SENS_VENTE } from '@/configuration/devisConf';

export default async function genererProduitSalon() {
  const supportCommerical = await getSupportCommercial(CATEGORIE_SALON);
  return {
    reference: null,
    libelle: null,
    liaisonsTarif: [],
    reglesAchat: [],
    supportCommercialId: supportCommerical.id,
    supportCommercial: supportCommerical,
    entiteCommerciale: entiteCommercialeGenerer(),
    schemaComptableId: null,
    schemaComptable: null,
    objectifsVente: [],
    produitSalon: {
      dateSignature: null,
      dateDebut: null,
      dateFin: null,
      produitParDefautId: null,
      prestations: [],
    },
    agenceId: null,
    societeId: null,
    sens: SENS_VENTE,
    commissionsVendeur: [],
    cgvs: [],
    demandeInterventionTypes: [],
    compteAnalytiqueId: null,
    regleFacturationId: null,
    marcheId: null,
    assistantId: null,
    renouvelable: true,
  };
}
